/**
 * 跳转动作
 */
export const JUMP_ACTION = {
  OPEN_GULLAK: 'open_gullak', // 打开存钱罐
  OPEN_DEPOSIT_CASH: 'open_deposit_cash', // 打开法币充值
  OPEN_WITHDRAW_CASH: 'open_withdraw_cash', // 打开法币提现
  OPEN_DEPOSIT_CRYPTO: 'open_deposit_crypto', // 打开数字货币充值
  OPEN_WITHDRAW_CRYPTO: 'open_withdraw_crypto', // 打开数字货币提现
  OPEN_AFFILIATE_SHARE: 'open_affiliate_share',  // 打开代理分享弹窗
  OPEN_WALLET_MODAL: 'open_wallet_modal',  // 打开充值提现弹窗
};
